var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFooter2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.05,
    height: 51.086,
    viewBox: "0 0 48.05 51.086",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#36c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M600.95,2845.24v-1.963a17.944,17.944,0,0,0-4.68-12.311,16.139,16.139,0,0,0-11.977-5.152h-1.621a16.141,16.141,0,0,0-11.977,5.152,17.945,17.945,0,0,0-4.68,12.311v1.963a7.05,7.05,0,0,0-6.568,7.02v3.069a7.039,7.039,0,0,0,7.03,7.029h3.96a1.291,1.291,0,0,0,1.289-1.287v-14.565a1.292,1.292,0,0,0-1.289-1.287h-1.846v-1.942c0-8.489,6.054-14.886,14.071-14.886h1.621c8.028,0,14.07,6.4,14.07,14.886v1.942h-1.845a1.292,1.292,0,0,0-1.288,1.287v14.554a1.292,1.292,0,0,0,1.288,1.288h1.8c-.526,6.719-5.152,8.274-7.3,8.629a4.526,4.526,0,0,0-4.3-3.123h-3.22a4.523,4.523,0,0,0,0,9.047h3.23a4.529,4.529,0,0,0,4.357-3.327,12.166,12.166,0,0,0,4.367-1.492c2.33-1.363,5.088-4.142,5.453-9.745a7.038,7.038,0,0,0,6.6-7.019v-3.07A7.013,7.013,0,0,0,600.95,2845.24Z",
    transform: "translate(-559.448 -2825.815)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFooter2);
export default __webpack_public_path__ + "static/media/icon-footer2.c754a4f7f7cf908916f0a987e25c739e.svg";
export { ForwardRef as ReactComponent };